import { render, staticRenderFns } from "./changePwdDc.vue?vue&type=template&id=7beb8b70&scoped=true"
import script from "./changePwdDc.vue?vue&type=script&lang=js"
export * from "./changePwdDc.vue?vue&type=script&lang=js"
import style0 from "./changePwdDc.vue?vue&type=style&index=0&id=7beb8b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb8b70",
  null
  
)

export default component.exports